
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic07On as ObiHydraulic07OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-07-on.js';
 
 
 

 
 export const ObiHydraulic07On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-07-on',
   elementClass: ObiHydraulic07OnElement,
   events: {
     
   }
  });
 
 